module.exports = __webpack_public_path__ + "static/img/claim-step-3.e7d5ccb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/claim-step-3.svg
// module id = /WIj
// module chunks = 1